import React, { useRef } from 'react';
import { connect } from 'react-redux';

import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { getEmptyMandatoryOrFieldsWithError } from 'apps/auth/components/form-multi/utils';
import { AMOUNT_FROM, AMOUNT_TO, AMOUNT_TO_CCY } from 'apps/auth/constants/fieldsName';
import { GA_EXCHANGE_FORM_NAME } from 'apps/auth/constants/formName';
import { AUTH_GA_POCKET } from 'apps/auth/constants/UrlConstants';
import { getCurrencyIcon, onIconRenderError } from 'apps/auth/helpers/utils';
import { useApp, useLanguage } from 'apps/auth/hooks/selectors';
import { CurrencyService } from 'apps/auth/services/currencyService';
import { ExchangingAmountValidationService } from 'apps/auth/services/exchangingAmountValidationService';

import ChangeAccountForExchangePopup from './popup/ChangeAccountForExchangePopup';
import GaCalculatorScreen from '../calculator/GACalculatorScreen';

const ExchangeCalculatorScreenPureComponent = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const popupRef = useRef(null);
    const validationService = new ExchangingAmountValidationService({
        minValidError: props.minValidError,
        maxValidError: props.maxValidError,
        maxPocketError: props.maxPocketError,
    });
    const apiFetchDataUrl = `/auth/ga/pocket/${props.pocket?.id}/exchange/calc.commission`;
    const saveMoneyCodeFetchUrl = `/auth/ga/pocket/${props.pocket?.id}/send.calculate?isFrom=true`;
    const fetchCurrencyUrl = `${AUTH_GA_POCKET}${props.pocket?.id}`;

    const getValidationError = (value, min, max, multiple, isFrom, currencyCode) => {
        return validationService.getValidationError(value, min, max, multiple, isFrom, props.pocket?.balance, currencyCode, lang, country);
    };

    const onSelectCurrencyClick = (e, currencies, amountCcy, ccyField) => {
        popupRef.current?.open(
            <ChangeAccountForExchangePopup
                currencies={currencies}
                current={amountCcy}
                field={ccyField}
                getCurrencyIcon={getCurrencyIcon}
                onError={onIconRenderError}
                popupRef={popupRef}
            />,
        );
    };

    const onContinueButtonClick = (e) => {
        if (props.freezeAction.current || !props.amountFrom.value || !props.amountTo.value) {
            e.preventDefault();
        } else {
            const errorFields = getEmptyMandatoryOrFieldsWithError([props.amountFrom, props.amountTo]);
            if (errorFields && errorFields.length > 0) {
                e.preventDefault();
            } else {
                props.freezeAction.current = true;
            }
        }
    };

    return (
        <>
            <GaCalculatorScreen
                formName={GA_EXCHANGE_FORM_NAME}
                fetchCommissionUrl={apiFetchDataUrl}
                getValidationError={getValidationError}
                freezeAction={props.freezeAction.current}
                isSend={false}
                currencyFrom={props.currencyFrom}
                currencyTo={CurrencyService.getCurrentCurrency(props.currenciesTo, props.amountToCcy)}
                currenciesFrom={props.currenciesFrom}
                currenciesTo={props.currenciesTo}
                fetchCurrencyUrl={fetchCurrencyUrl}
                onSelectCurrencyClick={onSelectCurrencyClick}
                onContinueButtonClick={onContinueButtonClick}
                promoCodeFetchUrl={saveMoneyCodeFetchUrl}
                getCurrencyIcon={getCurrencyIcon}
                onError={onIconRenderError}
            />
            <PopupNew ref={popupRef} overflowHidden={true} />
        </>
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        pocket: state.extra.pocket,
        minValidError: state.messages.jsMessages['site.js.ga.validation.min.valid.error'],
        maxValidError: state.messages.jsMessages['site.js.ga.validation.max.valid.error'],
        maxPocketError: state.messages.jsMessages['site.js.validation.max.pocket.value.error'],
        formName: ownProps.formName,
        currenciesTo: state.extra.availableAccountsTo,
        currencyFrom: state.extra.pocket?.pocketCurrency,
        currenciesFrom: state.extra.accountsFrom,
        freezeAction: ownProps.freezeAction,
        amountToCcy: state.form[ownProps.formName].fields[AMOUNT_TO_CCY].value,
        amountFrom: state.form[ownProps.formName].fields[AMOUNT_FROM],
        amountTo: state.form[ownProps.formName].fields[AMOUNT_TO],
    };
};

export const ExchangeCalculatorScreen = connect(mapStateToProps, null)(ExchangeCalculatorScreenPureComponent);
